export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const WHATSAPP_NUMBER = "447448671884";
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}`;
export const PHONE_DISPLAY = "+34 611 274 830";
export const PHONE_TEL = "+34611274830";
export const EMAIL = "hello@tenerifeexcursions.com";

export const IMAGES = {
  hero: "https://images.pexels.com/photos/14088842/pexels-photo-14088842.jpeg?auto=compress&cs=tinysrgb&w=2000",
  jetski: "https://images.pexels.com/photos/35767037/pexels-photo-35767037.jpeg?auto=compress&cs=tinysrgb&w=1200",
  catamaran: "https://images.unsplash.com/photo-1660337060268-1251cedc6bd0?q=80&w=1200&auto=format&fit=crop",
  teide: "https://images.pexels.com/photos/8387384/pexels-photo-8387384.jpeg?auto=compress&cs=tinysrgb&w=1200",
};

export const TRIP_META = {
  jetski: { price: 79, capacity: 10, duration_min: 120, time: "10:30", image: IMAGES.jetski },
  catamaran: { price: 59, capacity: 24, duration_min: 180, time: "13:00", image: IMAGES.catamaran },
  teide: { price: 69, capacity: 16, duration_min: 300, time: "16:00", image: IMAGES.teide },
};
export const TRIP_ORDER = ["jetski", "catamaran", "teide"];

export function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72, duration: 1.2 });
  else el.scrollIntoView({ behavior: "smooth" });
}
